<template>
  <div>
    <div class="floating-wrapper">
      <div
        v-if="openEmailReplayBox"
        class="floating-signals-table-email-feedbacks"
        :class="{'floating-signals-table-email-approval':Object.keys(client.emails_approval).length === 0}"
      >
        <span class="titlePresets">
          Choose Email Preset:
        </span>
        <ul class="text-center"  v-if="Object.keys(client.emails_approval).length !== 0">
          <li
            class="preset-li"
            v-for="(item, idx) in dictionaries.activity.email_presets"
            :key="idx"
            @click="[sendEmailPriset(item, client),$emit('cancelOpenEmailReplayBox')]"
          >
            {{ item.preset }}
          </li>

        </ul>
        <ul v-else >
          <li  class="preset-li"  @click="[sendEmailApprova(client),$emit('cancelOpenEmailReplayBox')]">
            Email Approval Request
          </li>
        </ul>
        <span @click="closeIt" class="cancel-edit-menu-item-EmailReplayBox"
              :class="{'cancel-edit-menu-item-email-approval':Object.keys(client.emails_approval).length === 0}"
          >Cancel
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { VueEditor, Quill } from "vue2-editor";
import { mapState, mapGetters, mapActions } from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
import { Globals } from "../../../../../global_constants/constants";

export default {
  name: "EmailPreSets",
  props: {
    openEmailReplayBox: {
      type: Boolean,
      required: false
    },
    client: {
      type: Object,
      required: false
    }
  },

  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["dictionaries"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"])
  },
  watch: {},
mounted() {
  // console.log(Object.keys(this.client.emails_approval).length !== 0);
},
  methods: {
    sendEmailApprova(client){
      const sendEmailReply = apiClientCreator(`client/email/send/requestApproval/${client.id}`)
    .post("", {

    }).then(a=>{
            // console.log(a);
          })
    },
    sendEmailPriset(item, client) {
      const sendEmailReply = apiClientCreator(`client/email/send/${client.id}`);
      sendEmailReply
        .post("", {
          tag: item.preset,
          client: client,
          presetId: item.id,
          email: client.emails[0].contact_value,
          clientFullName: client.full_name,
          fName: client.first_name,
          lName: client.last_name,
          message:
            client.full_name +
            ", " +
            item.preset +
            " " +
            client.full_name +
            " " +
            `${Globals.joomla_website}email.php?id=${client.id}`
        })
        .then(a => {
          // console.log(a+'hello');
        });
    },
    closeIt() {
      this.$emit("cancelOpenEmailReplayBox");
    },
    openEmailsCountRelay() {
      this.openEmailsCountRelayBox = true;
      this.$emit("emailsCountRelayClicked");
    },
    openReplay() {
      this.openEmailReplayBox = true;
    }
  }
};
</script>

<style scoped>
.floating-signals-table-email-feedbacks {
  position: absolute;
  top: 31px;
  left: -175px;
  width: 510px;
  z-index: 10001;
  border: solid 1px #ccc;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}
.floating-signals-table-email-feedbacks ul li {
  list-style-type: none;
  padding: 5px;
}
.floating-signals-table-email-approval ul li {
  margin-right: 35px;
  margin-bottom: 18px;
}
.bttns {
  font-family: Montserrat !important;
  width: fit-content;
  margin-top: 0.5rem;
  margin-left: 1rem;
  background: #44a2d2;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 10px;
  /*font-family: inherit;*/
  cursor: pointer;
}
.cancel-edit-menu-item-EmailReplayBox {
  padding: 5px;
  color: #f44336;
  font-weight: bold;
  position: absolute;
  top: 245px;
  left: 211px;
  cursor: pointer;
}
.floating-signals-table-email-count-relay {
  position: absolute;
  top: 50px;
  /*left: 254px;*/
  right: 0;
  width: 445px;
  z-index: 10001;
  border: solid 1px #ccc;
  padding: 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}
.preset-li {
  cursor: pointer;
}
.preset-li:hover {
  background: rgba(27, 109, 133, 0.99);
  color: white;
}
.floating-wrapper {
  position: relative;
  text-align: center;
  font-size: 10pt;
}
.text-center li {
  text-align: left;
  margin-left: 0;
  padding-left: 0;
}
.titlePresets {
  font-size: 9pt;
  font-weight: 500;
}
.cancel-edit-menu-item-email-approval {
  top: 40px;
  left: 106px;
}
.floating-signals-table-email-approval{
  width: 285px;
}
</style>
